import { createContext, useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";
import { updateUser } from "store/auth/authSlice";
import { setUnReadNotificationCount } from "store/common/commonSlice";
import { apiUrl } from "../config/apiUrl";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { access_token, isLogin, user } = useSelector(
    (state) => state.authAdminReducer
  );
  const socketRef = useRef(null);

  useEffect(() => {
    socketRef.current = io(apiUrl, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0,
    });

    if (isLogin) {
      socketRef.current.emit("join", { id: user?._id });
      socketRef.current.on("new-notification", ({ unReadCount }) => {
        dispatch(setUnReadNotificationCount(unReadCount));
      });
      socketRef.current.on("updated-user", (user) => {
        if (user) {
          dispatch(updateUser(user));
        }
      });
    }
    return () => {
      socketRef.current.off("new-notification");
      socketRef.current.off("updated-user");

      socketRef.current.disconnect();
    };
  }, [access_token, user, isLogin]);

  return (
    <WebSocketContext.Provider value={socketRef}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
